import { LoginPage } from "@/pages/LoginPage";
import { isLoggedInAtom } from "@/store/atoms/authAtoms";
import { createFileRoute, redirect } from "@tanstack/react-router";

interface LoginSearch {
  redirect?: string;
  msg?: string;
  error?: string;
}

export const Route = createFileRoute("/login")({
  beforeLoad: ({ context }) => {
    const isLoggedIn = context.store.get(isLoggedInAtom);

    if (isLoggedIn) {
      // If the user is logged in, redirect them from the root path ('/')
      // to their main dashboard or home page.
      throw redirect({
        to: "/payment", // <-- YOUR SPECIFIED PATH
        replace: true, // `replace` prevents the user from clicking "back" to this empty page.
      });
    }
  },
  validateSearch: (search: Record<string, unknown>): LoginSearch => {
    return {
      redirect: search.redirect as string | undefined,
      msg: search.msg as string | undefined,
      error: search.error as string | undefined,
    };
  },
  component: LoginRouteComponent,
});

function LoginRouteComponent() {
  const { redirect } = Route.useSearch();
  return <LoginPage redirectUrl={redirect} />;
}
